import * as yup from "yup";

export default defineNuxtPlugin(() => {
  yup.setLocale({
    mixed: {
      required: ({ path }) => {
        const words = path.replace(/([A-Z])/g, " $1").toLowerCase();
        const label = words.charAt(0).toUpperCase() + words.slice(1);
        return `${label} is required`;
      },
    },
  });
});
